// @flow

import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { i18nState } from 'redux-i18n'
import { reducer as toastrReducer } from 'react-redux-toastr'

import warehouse from './warehouse'
import merchant from './merchant'
import customerService from './customerService'
import login from './login'
import global from './global'
import returnDetails from './returnDetails'
import warehouseRecord from './warehouseRecord'
import changePassword from './changePassword'
import generalReturnDetails from './generalReturnDetails'
import resellBeta from './resellBeta'
import stockIn from './stockIn'
import stagingRecordList from './stagingRecordList'

export default combineReducers({
  routing: routerReducer,
  toastr: toastrReducer,
  i18nState,
  warehouse,
  merchant,
  customerService,
  returnDetails,
  warehouseRecord,
  login,
  changePassword,
  global,
  generalReturnDetails,
  resellBeta,
  stockIn,
  stagingRecordList,
})



// WEBPACK FOOTER //
// ./src/modules/index.js